import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'antd/dist/antd.css';
import 'react-quill/dist/quill.snow.css';
import './styles/style.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import trLocale from "antd/lib/locale/tr_TR";
import {ConfigProvider} from "antd";
import "moment/locale/tr"

ReactDOM.render(
   <ConfigProvider locale={trLocale}>
      <React.StrictMode>
         <App/>
      </React.StrictMode> </ConfigProvider>
   ,
   document.getElementById('root'),
);

serviceWorker.unregister();
